import { EventEmitter } from "events";
import AvailabilityService from "../services/AvailabilityService";
import { GroupAvailabilityStatus } from "../types";
import StoreContainer from "./StoreContainer";

class AvailabilityStore {
  private _emitter = new EventEmitter();
  private _groupAvailability: GroupAvailabilityStatus;
  private _intervalRef: any;
  private _availabilityLoaded: boolean;

  async loadGroupAvailability() {
    if (!this._availabilityLoaded) {
      await this.fetchAvailability();
    }
    this.startAvailabilityPing();
  }

  getGroupAvailability() {
    return this._groupAvailability;
  }

  isChatAvailableInternal() {
    return this._groupAvailability === GroupAvailabilityStatus.Available;
  }

  async isChatAvailable(callback: (isAvailable: boolean) => void) {
    //Boot needs to be complete before we try to check availability
    await StoreContainer.BootStore.waitForBoot();
    callback(this.isChatAvailableInternal());
  }

  stopAvailabilityPing() {
    clearInterval(this._intervalRef);
    this._intervalRef = undefined;
  }

  onAvailabilityChanged(callback: () => void) {
    this._emitter.addListener("availabilityChanged", callback);
  }

  private startAvailabilityPing() {
    if (
      StoreContainer.EngagementStore.availabilityPingingEnabled() &&
      !this._intervalRef
    ) {
      this._intervalRef = window.setInterval(async () => {
        var previousAvailability = this._groupAvailability;
        await this.fetchAvailability();
        const changed = this._groupAvailability !== previousAvailability;
        if (changed) {
          this._emitter.emit("availabilityChanged");
        }
      }, 30000);
    }
  }

  private async fetchAvailability() {
    var result = await AvailabilityService.loadGroupAvailability(
      StoreContainer.SettingStore.getSiteId(),
      StoreContainer.GroupStore.getPageGroupId()
    );

    this._availabilityLoaded = true;
    this._groupAvailability = result.StatusValue;
  }

  async isActiveGroupAvailable() {
    if (!StoreContainer.GroupStore.activeAndPageGroupsDiffer()) {
      return this.isChatAvailableInternal();
    }

    //If the groups are different, we need to get the availability specifically for the active group
    //Not going to bother storing the result of this since it's only needed one time in one spot for the moment
    const result = await AvailabilityService.loadGroupAvailability(
      StoreContainer.SettingStore.getSiteId(),
      StoreContainer.GroupStore.getActiveOrPageGroupId()
    );

    return result.StatusValue === GroupAvailabilityStatus.Available;
  }
}

export default AvailabilityStore;
